export function delayed( milliseconds = 100 ) {
    return new Promise(r => setTimeout(r, milliseconds));
}
